<template>
  <div>
    <WdsButton v-if="!disabled" id="btn-add-row" sm @click="() => spreadsheet.insertRow()">
      {{ $t('Add row') }} +
    </WdsButton>
    <input
      id="timesheet_jexcel_data"
      v-model="timesheetJson"
      disabled
      type="hidden"
      name="timesheet_jexcel"
    />
  </div>
</template>

<script>
import jspreadsheet from 'jspreadsheet-ce'
import moment from 'moment'
import 'jspreadsheet-ce/dist/jspreadsheet.css'
import 'jsuites/dist/jsuites.css'
import { WdsButton } from '@worksome/wds-components'

const DATE_FORMAT = 'YYYY-MM-DD'

export default {
  components: { WdsButton },
  props: {
    modelValue: { type: Array, default: () => [] },
    initialDate: {
      type: String,
      default: () => moment().format(DATE_FORMAT),
    },
    ratetype: { type: String, default: 'hourly' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      sheetdata: this.getInitialTimeSheetData(),
      timesheetJson: '',
      $t,
    }
  },
  computed: {
    sheetOptions() {
      return {
        editable: !this.disabled,
        data: this.modelValue,
        allowToolbar: true,
        columns: [
          {
            type: 'calendar',
            title: $t('Date'),
            width: '120px',
            options: {
              format: DATE_FORMAT,
            },
          },
          {
            type: 'numeric',
            title: this.ratetype === 'daily' ? $t('Days') : $t('Hours'),
            width: '100px',
          },
          {
            type: 'text',
            title: $t('Description'),
            width: '500px',
          },
        ],
        onchange: this.changed,
        onpaste: this.changed,
        oninsertrow: this.changed,
        ondeleterow: this.changed,
        onsort: this.changed,
      }
    },
  },
  watch: {
    modelValue(updatedValue) {
      this.spreadsheet.setData(updatedValue)
    },
  },
  mounted() {
    const spreadsheet = jspreadsheet(this.$el, this.sheetOptions)
    spreadsheet.hideIndex()
    Object.assign(this, { spreadsheet })
  },
  methods: {
    /* eslint-disable-next-line no-unused-vars */
    changed(instance, cell, x, y, value) {
      const jsonString = JSON.stringify(this.spreadsheet.getJson())
      this.timesheetJson = jsonString
      this.$emit('input', jsonString)
    },
    getInitialTimeSheetData() {
      return [[this.initialDate, '', '']]
    },
  },
}
</script>

<style>
#btn-add-row {
  position: absolute;
  bottom: -20px;
}

.jexcel > thead > tr > td {
  background: #eef3f7;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 13px;
  text-align: left;
}
.jexcel {
  border-right-color: #e0e4e8;
  border-bottom-color: #e0e4e8;
}
.jexcel > tbody > tr > td,
.jexcel > thead > tr > td {
  border-top-color: #e0e4e8;
  border-left-color: #e0e4e8;
}
.jexcel > tbody > tr > td {
  height: 24px;
  text-align: left !important;
}

/* Fix the styling to hide index, and still show corrent date picker */
.jexcel_hidden_index tr > td:first-child {
  display: block;
}
.jexcel_hidden_index
  tr
  > td:first-child:not(.jcalendar-set-day):not(.jcalendar-prev):not(.jcalendar-weekday) {
  display: none;
}
</style>
